module.exports = __webpack_public_path__ + "public/images/prizes/prize-2.e31c9ccececf84a21ed09256cfdd2221.jpeg";